(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[552],{

/***/ 66607:
/***/ (function(module) {

!function(e,i){ true?module.exports=i():0}(this,(function(){"use strict";return function(e,i,t){i.prototype.isBetween=function(e,i,s,f){var n=t(e),o=t(i),r="("===(f=f||"()")[0],u=")"===f[1];return(r?this.isAfter(n,s):!this.isBefore(n,s))&&(u?this.isBefore(o,s):!this.isAfter(o,s))||(r?this.isBefore(n,s):!this.isAfter(n,s))&&(u?this.isAfter(o,s):!this.isBefore(o,s))}}}));

/***/ }),

/***/ 90451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ share_Desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./framework/ui/desktop/popup/index.ts + 4 modules
var popup = __webpack_require__(16628);
// EXTERNAL MODULE: ./framework/ui/desktop/table/index.ts + 1 modules
var table = __webpack_require__(5540);
// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
// EXTERNAL MODULE: ./framework/ui/desktop/text/RequiredText.tsx
var RequiredText = __webpack_require__(25429);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./framework/ui/desktop/input/index.ts + 8 modules
var desktop_input = __webpack_require__(51909);
// EXTERNAL MODULE: ./framework/ui/desktop/select/index.ts
var desktop_select = __webpack_require__(64249);
// EXTERNAL MODULE: ./framework/ui/desktop/list/index.ts + 3 modules
var list = __webpack_require__(73255);
// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 8 modules
var desktop_button = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
;// CONCATENATED MODULE: ./components/style/common/mailshare.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: flex;\n	flex-direction: column;\n	margin-bottom: 20px;\n	> p {\n		display: inline-block;\n		margin-left: auto;\n		&::before {\n			top: 4px;\n			width: 0;\n			height: 0;\n			color: var(--red-color);\n			vertical-align: middle;\n			content: "*";\n		}\n	}\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	line-height: 1;\n	margin-bottom: 20px;\n	font-size: var(--medium-size);\n	color: var(--emp-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: var(--medium-size);\n	font-weight: normal;\n	color: var(--emp-color);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n					> p {\n						display: block;\n					}\n					input:not([type="checkbox"]),\n					> div > div,\n					textarea {\n						border-color: red;\n					}\n\n					input:focus {\n						border-color: currentcolor;\n					}\n			  '
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n					> p {\n						display: none;\n					}\n			  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	+ div {\n		padding-top: 10px;\n		padding-bottom: 0;\n		border-top: 1px dashed var(--line-color);\n	}\n	> span {\n		display: inline-block;\n		padding: 0 8px;\n	}\n\n	",
        "\n	",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 6px;\n	margin-top: 10px;\n	margin-left: 71px;\n	label {\n		line-height: 21px;\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: inline-block;\n	width: 50px;\n	margin-right: 20px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: inline-block;\n	width: 150px;\n	height: 40px;\n	margin-left: 10px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 10px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 20px;\n	border: 1px solid var(--line-color);\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 30px 40px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	align-items: flex-start;\n	padding: 15px 0 15px 40px;\n	border-top: 1px solid #ddd;\n	background: var(--disabled-color);\n	> input {\n		margin-right: 10px;\n	}\n	> label {\n		color: var(--emp-color);\n	}\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	gap: 6px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	padding-left: 10px;\n	line-height: 24px;\n	font-size: var(--default-size);\n	&::before {\n		position: absolute;\n		left: 0;\n		padding-right: 5px;\n		content: "-";\n	}\n'
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: center;\n	margin-top: 40px;\n	button {\n		width: 140px;\n	}\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: absolute;\n	top: 50%;\n	left: 10px;\n	height: 16px;\n	transform: translateY(-50%);\n\n	&::before {\n		display: inline;\n		color: var(--red-color);\n		content: "*";\n	}\n'
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	line-height: 1;\n	font-size: 14px;\n	text-align: right;\n	> span {\n		margin-right: 4px;\n	}\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	display: inline-block;\n	vertical-align: middle;\n\n	&::before {\n		display: inline;\n		color: var(--red-color);\n		content: "*";\n	}\n'
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}

var TextWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e5e532c1-0"
})(_templateObject());
var SubTitle = styled_components_browser_esm["default"].h4.withConfig({
    componentId: "sc-e5e532c1-1"
})(_templateObject1());
var ProductName = styled_components_browser_esm["default"].strong.withConfig({
    componentId: "sc-e5e532c1-2"
})(_templateObject2());
var TblLine = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e5e532c1-3"
})(_templateObject3());
var InputRow = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e5e532c1-4"
})(_templateObject6(), function(props) {
    return props.padding ? "\n		padding-bottom: 10px;\n	" : "";
}, function(props) {
    return props.wrong ? (0,styled_components_browser_esm.css)(_templateObject4()) : (0,styled_components_browser_esm.css)(_templateObject5());
});
var CheckWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e5e532c1-5"
})(_templateObject7());
var InputLabel = styled_components_browser_esm["default"].label.withConfig({
    componentId: "sc-e5e532c1-6"
})(_templateObject8());
var SelectWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e5e532c1-7"
})(_templateObject9());
var BulletList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-e5e532c1-8"
})(_templateObject10());
var AgreeBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e5e532c1-9"
})(_templateObject11());
var AgreeText = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e5e532c1-10"
})(_templateObject12());
var AgreeCheck = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e5e532c1-11"
})(_templateObject13());
var AgreeCheckWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e5e532c1-12"
})(_templateObject14());
var AgreeList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-e5e532c1-13"
})(_templateObject15());
var AgreeListItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-e5e532c1-14"
})(_templateObject16());
var BtnArea = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e5e532c1-15"
})(_templateObject17());
var RequiredCheck = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-e5e532c1-16"
})(_templateObject18());
var InfoText = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-e5e532c1-17"
})(_templateObject19());
var RequiredIcon = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-e5e532c1-18"
})(_templateObject20());


// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./hooks/services/queries/essential/code/useCode.ts
var useCode = __webpack_require__(88951);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventDetail.ts
var useEventDetail = __webpack_require__(7682);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsDetail.ts
var useGoodsDetail = __webpack_require__(3081);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./framework/utils/useConfigureAxios.ts
var useConfigureAxios = __webpack_require__(83839);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/common/modal/mail/Desktop.tsx

























var MailShare = function(props) {
    var ref, ref1;
    var query = (0,next_router.useRouter)().query;
    var dspGubun = props.dspGubun, _evCd = props.evCd, evCd = _evCd === void 0 ? query.evCd || "" : _evCd, _goodsCd = props.goodsCd, goodsCd = _goodsCd === void 0 ? query.goodsCd || "" : _goodsCd, _menu = props.menu, menu = _menu === void 0 ? query.menu || "" : _menu, _dspSid = props.dspSid, dspSid = _dspSid === void 0 ? query.dspSid || "" : _dspSid, overlay = (0,_object_without_properties/* default */.Z)(props, [
        "dspGubun",
        "evCd",
        "goodsCd",
        "menu",
        "dspSid"
    ]);
    var ref2 = (0,react.useState)(false), sameSender = ref2[0], setSameSander = ref2[1];
    var ref3 = (0,react.useState)("N"), collect = ref3[0], setCollect = ref3[1];
    var ref4 = (0,react.useState)(""), senderDomain = ref4[0], setSenderDomain = ref4[1];
    var ref5 = (0,react.useState)(false), showSenderDomain = ref5[0], setShowSenderDomain = ref5[1];
    var ref6 = (0,react.useState)(""), reciverDomain = ref6[0], setReciverDomain = ref6[1];
    var ref7 = (0,react.useState)(false), showReciverDomain = ref7[0], setShowReciverDomain = ref7[1];
    var ref8 = (0,react.useState)({
        sndrName: "",
        sndrEmail: "",
        rcptName: "",
        rcptEmail: "",
        collect: "",
        subject: "",
        message: ""
    }), required = ref8[0], setRequired = ref8[1];
    var ref9 = (0,react.useState)({
        dspGubun: dspGubun,
        evCd: evCd,
        goodsCd: goodsCd,
        menu: menu,
        dspSid: dspSid,
        rcptEmail: "",
        rcptName: "",
        sndrEmail: "",
        sndrName: "",
        subject: "",
        message: "",
        collectInfoYn: "N"
    }), value = ref9[0], setValue = ref9[1];
    /** 이메일 도메인 공통코드 */ var code = (0,useCode/* default */.ZP)("WEB_CUST_MAIL", {
        placeholderData: {
            body: []
        }
    }).data.body;
    var evNm = (0,useEventDetail/* default */.ZP)(evCd, {
        enabled: dspGubun === "P"
    }).data.body.evNm;
    var goodsNm = (0,useGoodsDetail/* default */.ZP)(goodsCd, {
        enabled: dspGubun === "G"
    }).data.body.goodsNm;
    var input = function(key) {
        return function(e) {
            var text = e.target.value.substring(0, key === "subject" ? 60 : 250);
            if ([
                "sndrEmailId",
                "sndrEmailDomain"
            ].indexOf(key) > -1) {
                var ref = (0,_sliced_to_array/* default */.Z)(value.sndrEmail.split("@"), 2), id = ref[0], tmp = ref[1], domain = tmp === void 0 ? "" : tmp;
                key === "sndrEmailId" && setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                    sndrEmail: "".concat(text, "@").concat(domain)
                }));
                key === "sndrEmailDomain" && setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                    sndrEmail: "".concat(id, "@").concat(text)
                }));
                setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                    sndrEmail: ""
                }));
            } else if ([
                "reciverEmailId",
                "reciverEmailDomain"
            ].indexOf(key) > -1) {
                var ref1 = (0,_sliced_to_array/* default */.Z)(value.rcptEmail.split("@"), 2), id1 = ref1[0], tmp1 = ref1[1], domain1 = tmp1 === void 0 ? "" : tmp1;
                key === "reciverEmailId" && setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                    rcptEmail: "".concat(text, "@").concat(domain1)
                }));
                key === "reciverEmailDomain" && setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                    rcptEmail: "".concat(id1, "@").concat(text)
                }));
                setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                    rcptEmail: ""
                }));
            } else {
                setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), (0,_define_property/* default */.Z)({}, key, text)));
                setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), (0,_define_property/* default */.Z)({}, key, "")));
            }
        };
    };
    var onSameSenderChecked = function(e) {
        return setSameSander(!sameSender);
    };
    var onCollectChecked = function(e) {
        setCollect(e.target.checked === true ? "Y" : "N");
        setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            collectInfoYn: e.target.checked === true ? "Y" : "N"
        }));
        setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
            collect: ""
        }));
    };
    var changeSenderDomain = function(domainName) {
        return function() {
            var ref = (0,_sliced_to_array/* default */.Z)(value.sndrEmail.split("@"), 1), id = ref[0];
            setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                sndrEmail: "".concat(id, "@").concat(domainName.toLowerCase())
            }));
            setSenderDomain(domainName);
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                sndrEmail: ""
            }));
            setShowSenderDomain(false);
        };
    };
    var changeReciverDomain = function(domainName) {
        return function() {
            var ref = (0,_sliced_to_array/* default */.Z)(value.rcptEmail.split("@"), 1), id = ref[0];
            setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                rcptEmail: "".concat(id, "@").concat(domainName.toLowerCase())
            }));
            setReciverDomain(domainName);
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                rcptEmail: ""
            }));
            setShowReciverDomain(false);
        };
    };
    var formValidation = function() {
        var sndrName = value.sndrName, sndrEmail = value.sndrEmail, rcptName = value.rcptName, rcptEmail = value.rcptEmail, subject = value.subject, message = value.message;
        var ref = (0,_sliced_to_array/* default */.Z)(sndrEmail.split("@"), 2), sndrId = ref[0], sndrDomain = ref[1];
        var ref1 = (0,_sliced_to_array/* default */.Z)(rcptEmail.split("@"), 2), rcptId = ref1[0], rcptDomain = ref1[1];
        /** 보내는 사람  */ if (sndrName.length === 0) {
            document.querySelector("#sndrName").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                sndrName: "이름을 입력하세요."
            }));
            return false;
        }
        if (/\s/g.test(sndrName)) {
            document.querySelector("#sndrName").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                sndrName: "공백을 제거하세요."
            }));
            return false;
        }
        if (sndrId.length === 0) {
            document.querySelector("#sndrEmailId").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                sndrEmail: "보내는 사람의 이메일 주소를 입력하세요."
            }));
            return false;
        }
        if (/\s/g.test(sndrId)) {
            document.querySelector("#sndrName").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                sndrName: "공백을 제거하세요."
            }));
            return false;
        }
        if (sndrDomain.length === 0) {
            document.querySelector("#sndrEmailDomain").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                sndrEmail: "보내는 사람의 이메일 도메인을 입력하세요."
            }));
            return false;
        }
        if (!ybutil_cjs/* validation.domain */.Uf.domain(sndrDomain)) {
            document.querySelector("#sndrEmailDomain").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                sndrEmail: "보내는 사람의 이메일 도메인을 확인하세요."
            }));
            return false;
        }
        /** 받는 사람 */ if (rcptName.length === 0) {
            document.querySelector("#rcptName").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                rcptName: "이름을 입력하세요."
            }));
            return false;
        }
        if (/\s/g.test(rcptName)) {
            document.querySelector("#sndrName").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                sndrName: "공백을 제거하세요."
            }));
            return false;
        }
        if (rcptId.length === 0) {
            document.querySelector("#reciverEmailId").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                rcptEmail: "받는 사람의 이메일 주소를 입력하세요."
            }));
            return false;
        }
        if (/\s/g.test(rcptId)) {
            document.querySelector("#sndrName").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                sndrName: "공백을 제거하세요."
            }));
            return false;
        }
        if (rcptDomain.length === 0) {
            document.querySelector("#reciverEmailDomain").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                rcptEmail: "받는 사람의 이메일 도메인을 입력하세요."
            }));
            return false;
        }
        if (!ybutil_cjs/* validation.domain */.Uf.domain(rcptDomain)) {
            document.querySelector("#reciverEmailDomain").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                rcptEmail: "받는 사람의 이메일 도메인을 확인하세요."
            }));
            return false;
        }
        /** 내용 */ if (subject.length === 0) {
            document.querySelector("#subject").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                subject: "제목을 입력하세요."
            }));
            return false;
        }
        if (message.length === 0) {
            document.querySelector("#message").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                message: "내용을 입력하세요."
            }));
            return false;
        }
        /** 개인수집 이용 동의 */ if (value.collectInfoYn === "N") {
            document.querySelector("#check-agree").focus();
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                collect: "개인정보 수집/이용에 동의하셔야합니다."
            }));
            return false;
        }
        return true;
    };
    var sendEmail = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, _tmp, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!formValidation()) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            (0,useConfigureAxios/* default */.Z)((_tmp.method = "POST", _tmp.url = "".concat(config_public/* default.ENV_ESSENTIAL_API_BASEPATH */.Z.ENV_ESSENTIAL_API_BASEPATH, "/api/mail/share"), _tmp.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                                subject: value.subject.trim(),
                                message: value.message.trim()
                            }), _tmp))
                        ];
                    case 1:
                        result = _state.sent();
                        result.data.code === "0000" && MessageUtil.alert("메일을 발송하였습니다.", function() {
                            overlay.close();
                        });
                        if (result.data.code !== "0000") {
                            throw new Error("");
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        MessageUtil.alert("메일을 발송에 실패하였습니다.");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function sendEmail() {
            return _ref.apply(this, arguments);
        };
    }();
    /** 보내는사람과 동일 */ (0,react.useEffect)(function() {
        var sndrName = value.sndrName, sndrEmail = value.sndrEmail;
        var ref = (0,_sliced_to_array/* default */.Z)(sndrEmail.split("@"), 2), id = ref[0], domain = ref[1];
        if (sameSender) {
            if (sndrName.length === 0) {
                setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                    sndrName: "이름을 입력하세요."
                }));
                setSameSander(false);
                return;
            } else if (!id || !domain) {
                setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                    sndrEmail: "보내는 사람의 이메일 주소를 입력하세요."
                }));
                setSameSander(false);
                return;
            } else if (!ybutil_cjs/* validation.domain */.Uf.domain(domain)) {
                setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                    sndrEmail: "이메일 도메인 형식이 잘못되었습니다."
                }));
                setSameSander(false);
                return;
            }
            setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                rcptName: value.sndrName,
                rcptEmail: value.sndrEmail
            }));
            setRequired((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, required), {
                sndrName: "",
                sndrEmail: ""
            }));
            setReciverDomain(senderDomain);
        } else {
            setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                rcptName: "",
                rcptEmail: ""
            }));
            setReciverDomain("");
        }
    }, [
        sameSender
    ]);
    (0,react.useEffect)(function() {
        if (dspGubun === "P") setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            subject: evNm
        }));
        if (dspGubun === "G") setValue((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
            subject: goodsNm
        }));
    }, [
        evNm,
        goodsNm
    ]);
    (0,react.useEffect)(function() {
        var event = function(e) {
            if (e.target.closest("#senderDomainSelect") || e.target.closest("#reciverDomainSelect")) return;
            setShowSenderDomain(false);
            setShowReciverDomain(false);
        };
        document.addEventListener("click", event);
        return function() {
            return document.removeEventListener("click", event);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlay), {
        title: "이메일 공유",
        size: "large",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                        children: "고객님이 보셨던 상품을 이메일로 공유하실 수 있습니다."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredIcon, {
                                title: "필수입력 아이콘"
                            }),
                            "는 필수입력 항목입니다."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                        children: "이메일 공유 정보 폼"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: "153px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                style: {
                                    width: "757px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        scope: "row",
                                        children: "상품명"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductName, {
                                            children: [
                                                dspGubun === "P" && evNm,
                                                dspGubun === "G" && goodsNm
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                        scope: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredCheck, {
                                                title: "필수입력"
                                            }),
                                            "보내는 사람"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TblLine, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                                                    padding: true,
                                                    wrong: !!required.sndrName,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel, {
                                                            children: "이름"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            id: "sndrName",
                                                            type: "text",
                                                            placeholder: "이름을 입력하세요.",
                                                            onChange: input("sndrName"),
                                                            value: value.sndrName
                                                        }),
                                                        required.sndrName && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredText/* default */.Z, {
                                                            children: required.sndrName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                                                    wrong: !!required.sndrEmail,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel, {
                                                            children: "이메일"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            id: "sndrEmailId",
                                                            type: "text",
                                                            placeholder: "이메일 아이디",
                                                            onChange: input("sndrEmailId"),
                                                            value: value.sndrEmail.split("@").at(0)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "@"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            id: "sndrEmailDomain",
                                                            type: "text",
                                                            readOnly: !!senderDomain,
                                                            placeholder: "이메일 도메인",
                                                            onChange: input("sndrEmailDomain"),
                                                            value: ((ref = value.sndrEmail.split("@")) === null || ref === void 0 ? void 0 : ref.at(1)) || ""
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWrap, {
                                                            id: "senderDomainSelect",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectBox */.jL, {
                                                                    onClick: function() {
                                                                        return setShowSenderDomain(!showSenderDomain);
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectLabel */.n5, {
                                                                        children: senderDomain.toLocaleLowerCase() || "직접입력"
                                                                    })
                                                                }),
                                                                showSenderDomain && /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_select/* SelectOptions */.PN, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            onClick: changeSenderDomain(""),
                                                                            children: "직접입력"
                                                                        }),
                                                                        code.map(function(item) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                onClick: changeSenderDomain(item.commCdId),
                                                                                children: item.commCdNm
                                                                            }, item.commCdId);
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        required.sndrEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredText/* default */.Z, {
                                                            children: required.sndrEmail
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                        scope: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredCheck, {
                                                title: "필수입력"
                                            }),
                                            "받는 사람"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TblLine, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                                                    padding: true,
                                                    wrong: !!required.rcptName,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel, {
                                                            children: "이름"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            id: "rcptName",
                                                            onChange: input("rcptName"),
                                                            value: value.rcptName,
                                                            placeholder: "이름을 입력하세요."
                                                        }),
                                                        required.rcptName && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredText/* default */.Z, {
                                                            children: required.rcptName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                                                    wrong: !!required.rcptEmail,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel, {
                                                            children: "이메일"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            placeholder: "이메일 아이디",
                                                            onChange: input("reciverEmailId"),
                                                            value: value.rcptEmail.split("@").at(0),
                                                            id: "reciverEmailId"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "@"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            placeholder: "이메일 도메인",
                                                            readOnly: !!reciverDomain,
                                                            onChange: input("reciverEmailDomain"),
                                                            value: ((ref1 = value.rcptEmail.split("@")) === null || ref1 === void 0 ? void 0 : ref1.at(1)) || "",
                                                            id: "reciverEmailDomain"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWrap, {
                                                            id: "reciverDomainSelect",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectBox */.jL, {
                                                                    onClick: function() {
                                                                        return setShowReciverDomain(!showReciverDomain);
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectLabel */.n5, {
                                                                        children: reciverDomain.toLocaleLowerCase() || "직접입력"
                                                                    })
                                                                }),
                                                                showReciverDomain && /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_select/* SelectOptions */.PN, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            onClick: changeReciverDomain(""),
                                                                            children: "직접입력"
                                                                        }),
                                                                        code.map(function(item) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                onClick: changeReciverDomain(item.commCdId),
                                                                                children: item.commCdNm
                                                                            }, item.commCdId);
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CheckWrap, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_input/* Checkbox */.XZ, {
                                                                    id: "check-all",
                                                                    value: "same",
                                                                    onChange: onSameSenderChecked,
                                                                    checked: sameSender
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "check-all",
                                                                    children: "보내는 사람과 동일"
                                                                })
                                                            ]
                                                        }),
                                                        required.rcptEmail && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredText/* default */.Z, {
                                                            children: required.rcptEmail
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                        scope: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredCheck, {
                                                title: "필수입력"
                                            }),
                                            "제목",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "(",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* BlueText */.IW, {
                                                children: value.subject.length
                                            }),
                                            "자 / 60자)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                                            wrong: !!required.subject,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_input/* TextInput */.oi, {
                                                    type: "text",
                                                    id: "subject",
                                                    onChange: input("subject"),
                                                    value: value.subject
                                                }),
                                                required.subject && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredText/* default */.Z, {
                                                    children: required.subject
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                        scope: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredCheck, {
                                                title: "필수입력"
                                            }),
                                            "내용",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "(",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* BlueText */.IW, {
                                                children: value.message.length
                                            }),
                                            "자 / 250자)"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                                            wrong: !!required.message,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_input/* Textarea */.gx, {
                                                    id: "message",
                                                    height: "200px",
                                                    onChange: input("message"),
                                                    value: value.message,
                                                    placeholder: "250자 이내로 작성하실 수 있습니다."
                                                }),
                                                required.message && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredText/* default */.Z, {
                                                    children: required.message
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BulletList, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* BulletListItem */.yx, {
                    children: [
                        "메일 발송 서비스 제공을 위해 아래와 같이 개인정보를 수집할 수 있습니다.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "단순 메일 보내기 기능으로써 기재 정보는 별도 보관되어지지 않습니다."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreeBox, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreeText, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreeList, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreeListItem, {
                                    children: "수집항목 : 보내는 사람, 받는 사람의 이름 및 이메일 주소"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreeListItem, {
                                    children: "수집목적 : 이용자의 상품 공유 메일 발송을 위함"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreeListItem, {
                                    children: "보유기간 : 보유하지 않음"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreeCheck, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                            wrong: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreeCheckWrap, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_input/* Checkbox */.XZ, {
                                            id: "check-agree",
                                            onChange: onCollectChecked,
                                            value: "이메일 발송 서비스 동의",
                                            checked: collect === "Y"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: "check-agree",
                                            children: "이메일 발송 서비스를 위한 개인정보 수집 이용에 동의합니다."
                                        })
                                    ]
                                }),
                                required.collect && /*#__PURE__*/ (0,jsx_runtime.jsx)(RequiredText/* default */.Z, {
                                    children: required.collect
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BtnArea, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                        text: "발송하기",
                        types: "confirm",
                        width: "basic",
                        onClick: sendEmail
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                        text: "취소",
                        types: "basic",
                        width: "basic",
                        onClick: overlay.close
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Desktop = (MailShare);

// EXTERNAL MODULE: ./public/P/images/ico/ico_sns_pc.png
var ico_sns_pc = __webpack_require__(14305);
var ico_sns_pc_default = /*#__PURE__*/__webpack_require__.n(ico_sns_pc);
;// CONCATENATED MODULE: ./components/style/common/share.tsx

function share_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n"
    ]);
    share_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function share_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	flex: 0 0 60px;\n	margin-bottom: 20px;\n"
    ]);
    share_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function share_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	+ li {\n		margin-left: 10px;\n	}\n"
    ]);
    share_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function share_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "0 0"
    ]);
    share_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function share_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "-70px 0"
    ]);
    share_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function share_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "-140px 0"
    ]);
    share_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function share_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "-210px 0"
    ]);
    share_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function share_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "-280px 0"
    ]);
    share_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function share_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "-350px 0"
    ]);
    share_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function share_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: block;\n	width: 60px;\n	height: 60px;\n	background-image: url(",
        ");\n	background-position: ",
        ";\n	> span {\n		font-size: 0;\n	}\n"
    ]);
    share_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function share_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	flex: 0 0 auto;\n	padding-top: 20px;\n	> button {\n		margin-left: 8px;\n	}\n"
    ]);
    share_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var ShareWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f0d05786-0"
})(share_templateObject());
var SnsBtnList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-f0d05786-1"
})(share_templateObject1());
var SnsBtnItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-f0d05786-2"
})(share_templateObject2());
var SnsBtnLink = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-f0d05786-3"
})(share_templateObject9(), (ico_sns_pc_default()), function(props) {
    if (props.sns === "facebook") {
        return (0,styled_components_browser_esm.css)(share_templateObject3());
    }
    if (props.sns === "twitter") {
        return (0,styled_components_browser_esm.css)(share_templateObject4());
    }
    if (props.sns === "kakaoStory") {
        return (0,styled_components_browser_esm.css)(share_templateObject5());
    }
    if (props.sns === "naver") {
        return (0,styled_components_browser_esm.css)(share_templateObject6());
    }
    if (props.sns === "kakaoTalk") {
        return (0,styled_components_browser_esm.css)(share_templateObject7());
    }
    if (props.sns === "email") {
        return (0,styled_components_browser_esm.css)(share_templateObject8());
    }
});
var LinkInputBlock = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f0d05786-4"
})(share_templateObject10());


// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsRecentEvent.ts
var useGoodsRecentEvent = __webpack_require__(92553);
// EXTERNAL MODULE: ./components/common/modal/share/Share.ts + 1 modules
var Share = __webpack_require__(75373);
;// CONCATENATED MODULE: ./components/common/modal/share/Desktop.tsx
/* eslint-disable no-shadow */ 




















var Desktop_ShareWrap = ShareWrap, Desktop_SnsBtnList = SnsBtnList, Desktop_SnsBtnItem = SnsBtnItem, Desktop_SnsBtnLink = SnsBtnLink, Desktop_LinkInputBlock = LinkInputBlock;
var DesktopComponent = function(props) {
    var _baseUrl = props.baseUrl, baseUrl = _baseUrl === void 0 ? "".concat(config_public/* default.ENV_PRODUCT_URL */.Z.ENV_PRODUCT_URL).concat(location.pathname) : _baseUrl, parameter = props.parameter, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "baseUrl",
        "parameter"
    ]);
    var share = new Share/* default */.Z(baseUrl, parameter);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref[0];
    (0,react.useEffect)(function() {
        Kakao && !Kakao.isInitialized() && Kakao.init(config_public/* default.ENV_KAKAO_APP_KEY */.Z.ENV_KAKAO_APP_KEY);
        return function() {
            return Kakao.cleanup();
        };
    }, []);
    // 아래는 Braze 관련 로직
    var path = location.pathname;
    var ref1 = (0,react.useState)(null), detailPackage = ref1[0], setDetailPackage = ref1[1];
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var evCd = query === null || query === void 0 ? void 0 : query.evCd;
    var goodsCd = query === null || query === void 0 ? void 0 : query.goodsCd;
    (0,react.useEffect)(function() {
        if (path.includes("detailPackage") && evCd) {
            (0,useEventDetail/* eventDetailAsync */.sP)(evCd).then(function(fetched) {
                var ref;
                var body = (ref = fetched.data) === null || ref === void 0 ? void 0 : ref.body;
                if (body) {
                    setDetailPackage(body);
                }
            }).catch(function(e) {
                ;
            });
        }
        if (path.includes("detailPackage") && goodsCd) {
            (0,useGoodsRecentEvent/* goodsRecentEventAsync */.BL)(goodsCd).then(function(fetched) {
                var ref, ref1;
                var fetchedEvCd = (ref = fetched.data) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.evCd;
                (0,useEventDetail/* eventDetailAsync */.sP)(fetchedEvCd).then(function(detailFetched) {
                    var ref;
                    var body = (ref = detailFetched.data) === null || ref === void 0 ? void 0 : ref.body;
                    if (body) {
                        setDetailPackage(body);
                    }
                }).catch(function(e) {
                    ;
                });
            }).catch(function(e) {
                return console.error(e);
            });
        }
    }, []);
    // tagging
    var ref2 = path.includes("detailPackage") ? {
        taggingName: "pkg_share_dtl",
        taggingData: detailPackage
    } : {
        taggingName: "pkg_share_goodsCd",
        taggingData: {
            parameter: parameter
        }
    }, taggingName = ref2.taggingName, taggingData = ref2.taggingData;
    var taggingClick = (0,useTagging/* useTaggingClick */.b)(taggingName, taggingData).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.kZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
        title: "공유하기",
        size: "small",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Desktop_ShareWrap, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Desktop_SnsBtnList, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_SnsBtnItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_SnsBtnLink, {
                                sns: "facebook",
                                href: "#",
                                onClick: function(e) {
                                    e.preventDefault();
                                    share.facebook();
                                    taggingClick({
                                        shareCh: "페이스북"
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "페이스북"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_SnsBtnItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_SnsBtnLink, {
                                sns: "naver",
                                href: "#",
                                onClick: function(e) {
                                    e.preventDefault();
                                    share.naver();
                                    taggingClick({
                                        shareCh: "네이버"
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "네이버"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_SnsBtnItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_SnsBtnLink, {
                                sns: "kakaoTalk",
                                href: "#",
                                onClick: function(e) {
                                    e.preventDefault();
                                    share.kakaotalk();
                                    taggingClick({
                                        shareCh: "카카오톡"
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "카카오톡"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_SnsBtnItem, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop_SnsBtnLink, {
                                sns: "email",
                                href: "#",
                                onClick: function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
                                        var _tmp, availEvCd, avail;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    e.preventDefault();
                                                    _tmp = {};
                                                    taggingClick((_tmp.shareCh = "이메일", _tmp));
                                                    if (!(router.asPath.indexOf("localList") > -1)) return [
                                                        3,
                                                        1
                                                    ];
                                                    open(function(overlay) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop, (0,_object_spread/* default */.Z)({
                                                            dspGubun: "G",
                                                            goodsCd: share.search.goodsCd
                                                        }, overlay));
                                                    });
                                                    return [
                                                        3,
                                                        4
                                                    ];
                                                case 1:
                                                    availEvCd = "";
                                                    if (!!evCd) return [
                                                        3,
                                                        3
                                                    ];
                                                    return [
                                                        4,
                                                        (0,useGoodsRecentEvent/* goodsRecentEventAsync */.BL)(goodsCd)
                                                    ];
                                                case 2:
                                                    avail = _state.sent();
                                                    availEvCd = avail.data.body.evCd;
                                                    _state.label = 3;
                                                case 3:
                                                    open(function(overlay) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop, (0,_object_spread/* default */.Z)({
                                                            evCd: availEvCd || evCd,
                                                            dspGubun: "P"
                                                        }, overlay));
                                                    });
                                                    _state.label = 4;
                                                case 4:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(e) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "이메일"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Desktop_LinkInputBlock, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_input/* TextInput */.oi, {
                            value: share.url,
                            readOnly: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* TextButton */.Av, {
                            text: "링크복사",
                            size: "default",
                            types: "basic",
                            onClick: function() {
                                share.writeText();
                                taggingClick({
                                    shareCh: "링크복사"
                                });
                            }
                        })
                    ]
                })
            ]
        })
    }));
};
var Desktop_Desktop = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "Modal Share Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var share_Desktop = (Desktop_Desktop);


/***/ }),

/***/ 50142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SSOLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _COMPONENTS_common_commonUtil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72425);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






function SSOLink(_param) {
    var href = _param.href, onClick = _param.onClick, children = _param.children, _target = _param.target, target = _target === void 0 ? "_self" : _target, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "href",
        "onClick",
        "children",
        "target"
    ]);
    var handleClick = function(e) {
        e.preventDefault();
        // 기존 클릭 이벤트 실행
        if (onClick) onClick(e);
        // SSO 처리 후 리다이렉트
        (0,_COMPONENTS_common_commonUtil__WEBPACK_IMPORTED_MODULE_1__/* .getSSOUrl */ .jq)(href).then(function(redirectUrl) {
            window.open(redirectUrl, target);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        href: href,
        onClick: handleClick
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 25429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93391);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: block;\n    margin-top: 5px;\n    font-size: var(--basic-size);\n    color: var(--red-color);\n    line-height: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Text = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].p.withConfig({
    componentId: "sc-8b1c2754-0"
})(_templateObject());
var RequiredText = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RequiredText);


/***/ }),

/***/ 71392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);


/**
 * useCountdown
 * @param {Dayjs} targetDate - 목표 시간
 * @returns {string | null} - 남은 시간 "(dd일) hh:mm:ss" 형식 또는 null
 */ var useCountdown = function(targetDate) {
    if (!dayjs__WEBPACK_IMPORTED_MODULE_1___default().isDayjs(targetDate)) return null;
    var calculateTimeLeft = function() {
        var now = dayjs__WEBPACK_IMPORTED_MODULE_1___default()();
        var diff = targetDate.diff(now);
        if (diff <= 0) return null; // 목표 시간이 지나면 null 반환
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
        var seconds = Math.floor(diff % (1000 * 60) / 1000);
        return "".concat(days > 0 ? "".concat(days, "일 ") : "").concat(hours >= 10 ? hours : "0".concat(hours), ":").concat(minutes >= 10 ? minutes : "0".concat(minutes), ":").concat(seconds >= 10 ? seconds : "0".concat(seconds));
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(calculateTimeLeft()), timeLeft = ref[0], setTimeLeft = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timer = setInterval(function() {
            var updatedTimeLeft = calculateTimeLeft();
            if (!updatedTimeLeft) clearInterval(timer); // 목표 시간이 지나면 타이머 종료
            setTimeLeft(updatedTimeLeft);
        }, 1000);
        return function() {
            return clearInterval(timer);
        }; // 클린업
    }, [
        targetDate
    ]);
    return timeLeft;
};
/* harmony default export */ __webpack_exports__["Z"] = (useCountdown);


/***/ }),

/***/ 28906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_utils_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42277);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/selectOne`
 * parameter
 *      goodsCd: string
 * ```*/ var key = "useGlobalGoodsLive";
var getPath = function() {
    return "".concat("https://support.ybtour.co.kr", "/api/bff/link/global/selectOne");
};
/** ```
 * 공통 텍스트 배너조회 API
 *   `/api/bff/link/global/selectOne`
 * parameter
 *      goodsCd: string
 * ```*/ var useGlobalGoodsLive = function() {
    var goodsCd = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", options = arguments.length > 1 ? arguments[1] : void 0;
    try {
        return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            queryKey: [
                key,
                goodsCd,
                getPath()
            ],
            queryFn: function() {
                return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                    url: getPath(),
                    method: "GET",
                    params: {
                        goodsCd: goodsCd
                    }
                }).then(function(r) {
                    return r.data;
                });
            },
            throwOnError: false
        }, options));
    } catch (error) {
        _FRAMEWORK_utils_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(error);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (useGlobalGoodsLive);



/***/ }),

/***/ 72204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, bannerContentsSSR */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 콘텐츠 구분 코드 배너 목록 조회
 *   `/pkg/common/contents/${diviCd}`
 * parameter
 * 		diviCd : WEB_CONT_DIVI_CD 공통코드값
 * ```*/ var key = "useBannerContents";
var getPath = function(diviCd) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/common/contents/").concat(diviCd);
};
/** ```
 * 콘텐츠 구분 코드 배너 목록 조회 SSR
 *   `/pkg/common/contents/${diviCd}`
 * parameter
 * 		diviCd : WEB_CONT_DIVI_CD 공통코드값
 * ```*/ var bannerContentsSSR = function(diviCd) {
    return useConfigureAxios(getPath(diviCd));
};
/** ```
 * 콘텐츠 구분 코드 배너 목록 조회
 *   `/pkg/common/contents/${diviCd}`
 * parameter
 * 		diviCd : WEB_CONT_DIVI_CD 공통코드값
 * ```*/ var useBannerContents = function(diviCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(diviCd)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(diviCd)
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useBannerContents);



/***/ }),

/***/ 82767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 상품 배너 가져오기
 *   `/goods/banner/deal`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var key = "useBannerGoodsDeal";
var getPath = function() {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/banner/deal");
};
/** ```
 * 상품 배너 가져오기
 *   `/goods/banner/deal`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/ var useBannerGoodsDeal = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(),
                params: {
                    goodsCd: goodsCd
                }
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useBannerGoodsDeal);



/***/ }),

/***/ 38307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getPath, key */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83839);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 상품 옐로PICK 배너 정보 api
 *   `/pkg/goods/banner/pick`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/ var key = "useGoodsBannerPick";
var getPath = function() {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/banner/pick");
};
/** ```
 * 상품 옐로PICK 배너 정보 api
 *   `/pkg/goods/banner/pick`
 * parameter
 *   `cmmnGrpCode` 공통그룹코드
 * ```*/ var useGoodsBannerPick = function(goodsCd, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath()
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                url: getPath(),
                params: {
                    goodsCd: goodsCd
                }
            }).then(function(r) {
                return r.data;
            });
        },
        gcTime: Infinity,
        staleTime: Infinity,
        throwOnError: false
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsBannerPick);



/***/ }),

/***/ 14305:
/***/ (function(module) {

module.exports = "data:image/png;base64,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"

/***/ })

}]);